import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddPayment from "../../../containers/admin/payment/models/add-payment";
import SearchBar from "../../../containers/admin/payment/searchbar";
import PaymentTable from "../../../containers/admin/payment/table";
import { getAllStudentsRequest } from "../../../modules/admin-modules/students/Actions";

const PER_PAGE = 10;

const Payment = () => {
  const dispatch = useDispatch();
  const count = useSelector((state) => state.students.count);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const totalPages = Math.max(1, Math.ceil((Number(count) || 0) / PER_PAGE));

  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [count, page, totalPages]);

  useEffect(() => {
    setPage(1);
  }, [searchTerm]);

  useEffect(() => {
    const timeId = setTimeout(() => {
      dispatch(getAllStudentsRequest(page, searchTerm));
    }, 200);

    return () => {
      clearTimeout(timeId);
    };
  }, [searchTerm, page, dispatch]);

  return (
    <Layout>
      <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
      <PaymentTable setSelectedData={setSelectedData} page={page} setPage={setPage} />
      <AddPayment selectedData={selectedData} setSelectedData={setSelectedData} />
    </Layout>
  );
};

export default Payment;
